// src/components/admin/StatusBadge.jsx
import React from 'react';

const StatusBadge = ({ status, type = 'default', size = 'md' }) => {
  // Define color schemes for different types
  const colorSchemes = {
    success: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      dot: 'bg-green-500'
    },
    warning: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-800',
      dot: 'bg-yellow-500'
    },
    danger: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      dot: 'bg-red-500'
    },
    info: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      dot: 'bg-blue-500'
    },
    default: {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      dot: 'bg-gray-500'
    }
  };

  // Define size classes
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-0.5 text-sm',
    lg: 'px-2.5 py-1 text-sm'
  };

  // Get the appropriate color scheme
  const colors = colorSchemes[type] || colorSchemes.default;
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  // Map status to type for automatic coloring
  const getStatusType = (status) => {
    if (!status) return 'default';
    
    const statusLower = status.toLowerCase();
    
    if (statusLower.includes('active') || statusLower.includes('success') || statusLower.includes('completed')) {
      return 'success';
    }
    
    if (statusLower.includes('pending') || statusLower.includes('warning') || statusLower.includes('in progress')) {
      return 'warning';
    }
    
    if (statusLower.includes('inactive') || statusLower.includes('error') || statusLower.includes('failed') || statusLower.includes('deleted')) {
      return 'danger';
    }
    
    if (statusLower.includes('info') || statusLower.includes('draft')) {
      return 'info';
    }
    
    return 'default';
  };

  // Get the final color scheme based on status if type is not explicitly provided
  const finalColors = type === 'default' ? colorSchemes[getStatusType(status)] || colorSchemes.default : colors;

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${finalColors.bg} ${finalColors.text} ${sizeClass}`}>
      <span className={`w-1 h-1 me-1 rounded-full ${finalColors.dot}`}></span>
      {status}
    </span>
  );
};

export default StatusBadge;